import { notification } from 'antd';
import { openNotification } from './openNotificationCustomized';
import { getUnit } from '../../store/utils';
import { track } from '../../tracking';
import { changePathAndFocus } from '../../pages/prescriptionPad/magicBox/magicBoxUtils';
import { MEDICAL_RECORDS } from '../../pages/prescriptionPad/magicBox/magicBoxTableElements';
import { his } from '../../pages/history';

export const openNewMRNotification = (newMedRecordsSinceLastVisit: number, pxId: string): void => {
    const key = Date.now().toString();

    const onClick = () => {
        track('GO_TO_PATIENT_OVERVIEW_MR', { from: 'pad-notification' });

        changePathAndFocus(MEDICAL_RECORDS, his, pxId, 'edit', 'patient-overview');
        notification.close(key);
    };

    openNotification({
        key,
        message: (
            <p className="font-400">
                {newMedRecordsSinceLastVisit} new medical{' '}
                {getUnit('records', newMedRecordsSinceLastVisit.toString())} were added for this
                visit
            </p>
        ),
        duration: 20,
        notificationType: 'success',
        description: undefined,
        onClick,
        className: 'cursor-pointer',
    });
};
